import { Button } from '@/components/ui';
import type { OrderBy } from '@shared/types';
import { X } from 'lucide-react';

export interface QueryOrderByRowProps {
  order: OrderBy;
  index: number;
  availableFields: string[];
  onChange: (index: number, order: OrderBy) => void;
  onRemove: (index: number) => void;
}

export function QueryOrderByRow({
  order,
  index,
  availableFields,
  onChange,
  onRemove,
}: QueryOrderByRowProps) {
  return (
    <div className="flex items-center gap-2 hover:bg-muted/20 transition-colors">
      <select
        value={order.field}
        onChange={(e) => onChange(index, { ...order, field: e.target.value })}
        className="flex-1 h-9 cursor-pointer rounded-md border border-input bg-background px-3 py-1 text-sm"
      >
        <option value="">Select field</option>
        {availableFields.map((field) => (
          <option key={field} value={field}>
            {field === '__id__' ? 'Document ID' : field}
          </option>
        ))}
      </select>
      <select
        value={order.direction}
        onChange={(e) =>
          onChange(index, {
            ...order,
            direction: e.target.value as 'asc' | 'desc',
          })
        }
        className="h-9 cursor-pointer rounded-md border border-input bg-background px-3 py-1 text-sm"
      >
        <option value="asc">Ascending</option>
        <option value="desc">Descending</option>
      </select>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onRemove(index)}
        className="h-9 w-9"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
